<template>
  <div class="slidebar" :class="navbarClass">
    <div class="slidebar__inner">
      <div class="slidebar__left">
        <img v-if="navbarClass === 'solid'" src="@/assets/logo_block.png" class="slidebar__logo">
        <img v-else src="@/assets/logo_white.png" class="slidebar__logo">
        <router-link
          v-for="(item,index) in navs"
          :key="index"
          :to="item.path"
          class="slidebar__item"
          :class="{
            'slidebar__item--active': index === current
          }"
        >
          {{ item.name }}
        </router-link>
      </div>
      <div class="slidebar__right">
        <div class="slidebar__btn-contact" @click="contactVisible = !contactVisible">联系我们</div>
      </div>
    </div>

    <contact-popup ref="contactPopup" :visible.sync="contactVisible" />

  </div>
</template>

<script>

import ContactPopup from '@/components/ContactPopup/index.vue'

export default {
  name: 'Slidebar',
  components: { ContactPopup },
  data() {
    return {
      current: 0,
      navs: [
        {
          name: '首页',
          path: '/',
          currenPaths: ['/']
        },
        {
          name: '关于我们',
          path: '/about',
          currenPaths: ['/about']
        },
        {
          name: '文章',
          path: '/article',
          currenPaths: ['/article', '/article/details']
        }
      ],
      isTransparent: true,
      scrollThreshold: 80, // 滚动阈值，超过这个值切换导航栏样式，
      solid: false, // 是否固定样式，如果固定滑动事件则不再做处理
      contactVisible: false
    }
  },
  computed: {
    navbarClass() {
      return this.isTransparent ? 'transparent' : 'solid'
    }
  },
  watch: {
    '$route'(to) {
      this.init()
    }
  },
  mounted() {
    this.init()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    init() {
      const {
        sidebarSolid,
        activeMenu
      } = this.$route.meta
      this.solid = !!sidebarSolid
      this.isTransparent = !this.solid
      const index = this.navs.findIndex(nav => nav.path === activeMenu)
      if (index >= 0) {
        this.current = index
      } else {
        this.current = 0
      }
    },
    handleScroll() {
      if (this.solid) {
        return
      }
      // 使用requestAnimationFrame优化滚动性能
      if (!this.ticking) {
        requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop
          // 控制导航栏透明状态
          this.isTransparent = scrollTop < this.scrollThreshold
          this.ticking = false
        })
        this.ticking = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.slidebar {
  position: fixed;
  height: 80px;
  z-index: 99;
  width: 100%;

  &__inner {
    max-width: 1195px;
    min-width: 900px;
    display: flex;
    align-items: center;
    height: 100%;
    margin: 0 auto;
    justify-content: space-between;
  }

  &__left {
    display: flex;
    align-items: center;
    flex: 1;
    height: 100%;
  }

  &__right {
    flex-shrink: 0;
  }

  &__logo {
    margin-right: 40px;
    height: 56px;
  }

  &__item {
    width: 132px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 21px;
    cursor: pointer;
    text-decoration: none;

    &--active {
      color: #0D1116;
      background-color: white;
    }

  }

  &__btn-contact {
    width: 149px;
    height: 41px;
    background: #FFFFFF;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 16px;
    color: #1B1B1B;
    line-height: 21px;
    cursor: pointer;
  }
}

.solid.slidebar {
  background-color: white !important;

  &__logo {
    margin-right: 40px;
    height: 56px;
  }

  .slidebar__item {
    color: #0D1116;
  }

  .slidebar__item--active {
    color: white !important;
    background-color: #268ECB !important;
  }

  .slidebar__btn-contact {
    background: #268ECB;
    color: white;
  }
}
</style>
